import { Box } from '@mui/material';

import { Skeleton } from '@/components';

import { EpisodeCardSmallDimensions } from '../../constants';

interface EpisodeCardSkeletonProps {
  includeText?: boolean;
}

export const EpisodeCardSmallSkeleton = ({
  includeText = false,
}: EpisodeCardSkeletonProps) => (
  <Box sx={{ width: EpisodeCardSmallDimensions.width, display: 'flex' }}>
    <Box
      sx={{
        height: EpisodeCardSmallDimensions.coverImageWidth,
        width: EpisodeCardSmallDimensions.coverImageWidth,
        borderRadius: 4,
        overflow: 'hidden',
        mr: 1,
      }}>
      <Skeleton variant="rounded" />
    </Box>
    {includeText && (
      <Box
        style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 0.5 }}>
        <Skeleton height={24} width="30%" />
        <Skeleton height={36} width="90%" />
        <Skeleton height={36} width="80%" />
      </Box>
    )}
  </Box>
);
